import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_BATCH_LIST = 'GET_BATCH_LIST';
export const GET_BATCH_LIST_SUCCESS = 'GET_BATCH_LIST_SUCCESS';
export const GET_BATCH_LIST_FAIL = 'GET_BATCH_LIST_FAIL';
export const GET_BATCH_LIST_RESET = 'GET_BATCH_LIST_RESET';

export const getBatchList = (params) => {
	console.log("Action: GET_BATCH_LIST triggered"); // Debug log
	return {
		type: GET_BATCH_LIST,
		params,
	};
};

export const getBatchListSuccess = (response) => {
	console.log("Action: GET_BATCH_LIST_SUCCESS triggered", response); // Debug log
	return {
		type: GET_BATCH_LIST_SUCCESS,
		response,
	};
};

export const getBatchListFail = (response) => {
	console.log("Action: GET_BATCH_LIST_FAIL triggered", response); // Debug log
	return {
		type: GET_BATCH_LIST_FAIL,
		response,
	};
};

export const getBatchListReset = () => {
	return {
		type: GET_BATCH_LIST_RESET,
	};
};

export const getBatchListApi = (data) => {
	return (dispatch) => {
		dispatch(getBatchList());
		console.log("Making API call to /batch/list"); // Debug log
		
		return axios
			.get(`${config.api.base_url}/batch/list`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				console.log("API Response:", response.data); // Debug log
				dispatch(getBatchListSuccess(response.data));
			})
			.catch((error) => {
				console.error("API Error:", error);
				dispatch(getBatchListFail(error.response ? error.response.data : error.message));
			});
	};
}; 